/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { type ForteFlags } from '@/features/forte';

/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 *
 * @param experimentId - The experiment ID from Monetate/Kibo decision API
 * @returns User-friendly search platform name for analytics tracking
 * @example
 * getSearchPlatform('vertex')
 * // Returns: 'VAIS:C'
 *
 * @example
 * getSearchPlatform('elasticsearch')
 * // Returns: 'ELASTIC'
 *
 * @example
 * getSearchPlatform(undefined)
 * // Returns: 'ELASTIC' (default)
 */
export function getSearchPlatform(experimentId: ForteFlags['experimentId']): string {
  switch (experimentId) {
    case 'vertex':
      return 'VAIS:C';
    case 'elasticsearch':
    default:
      return 'ELASTIC';
  }
}

/**
 * Determines if the current search platform is using Google Cloud Retail
 * (either VAIS:C or ELASTIC).
 *
 * @param experimentId - The experiment ID from Monetate/Kibo decision API
 * @returns True if using Google Cloud Retail (elasticsearch or vertex), false otherwise
 *
 * @example
 * isGoogleRetailPlatform('elasticsearch')
 * // Returns: true
 *
 * @example
 * isGoogleRetailPlatform('vertex')
 * // Returns: true
 */
export function isGoogleRetailPlatform(experimentId: ForteFlags['experimentId']): boolean {
  return experimentId === 'elasticsearch' || experimentId === 'vertex';
}
